import { Link } from "react-router-dom";
import { C } from "../constants/theme";
import FadeIn from "../components/ui/FadeIn";
import Hero from "../components/sections/Hero";
import Vision from "../components/sections/Vision";
import Philosophy from "../components/sections/Philosophy";
import DaySchedule from "../components/sections/DaySchedule";
import WeeklyStructure from "../components/sections/WeeklyStructure";
import ForMothers from "../components/sections/ForMothers";
import Enrol from "../components/sections/Enrol";

const Home = () => {
  return (
  <div style={{ paddingTop: 0 }}>
    <Hero />

    <section style={{ background:C.cream, padding:"0 6vw 70px" }}>
      <div style={{ maxWidth:1100, margin:"0 auto" }}>
        <FadeIn>
          <div style={{ textAlign:"center", marginBottom:32 }}>
            <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.mint, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:10 }}>Four Ways to Grow With Us</div>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(250px,1fr))", gap:20 }}>
            <div style={{ background:C.white, borderRadius:20, padding:"26px 28px", boxShadow:"0 4px 16px rgba(0,0,0,0.05)", borderTop:`5px solid ${C.mint}` }}>
              <div style={{ fontFamily:"Nunito", fontWeight:800, fontSize:11, letterSpacing:"0.06em", textTransform:"uppercase", color:C.mint, marginBottom:8 }}>Open Now · Running Since 2024</div>
              <div style={{ fontFamily:"Fredoka One", fontSize:21, color:C.navy, marginBottom:8 }}>Afterschool Socialisation Club</div>
              <p style={{ fontFamily:"Nunito", fontSize:14, color:C.text, lineHeight:1.75, margin:0 }}>Our onsite home base — a warm, faith-centred rhythm of learning, play, and community for children and the mothers who stay with them. <b>Ages 2.5 – 12.</b></p>
            </div>
            <div style={{ background:C.white, borderRadius:20, padding:"26px 28px", boxShadow:"0 4px 16px rgba(0,0,0,0.05)", borderTop:`5px solid ${C.coral}` }}>
              <div style={{ fontFamily:"Nunito", fontWeight:800, fontSize:11, letterSpacing:"0.06em", textTransform:"uppercase", color:C.coral, marginBottom:8 }}>Opening January 2027</div>
              <div style={{ fontFamily:"Fredoka One", fontSize:21, color:C.navy, marginBottom:8 }}>Mini Muslims Nest Preschool</div>
              <p style={{ fontFamily:"Nunito", fontSize:14, color:C.text, lineHeight:1.75, margin:"0 0 12px" }}>Six years of curriculum research, ECE study, and live testing through the club — now becoming a dedicated early-years program. <b>Ages 4 – 7.</b></p>
              <Link to="/programs/preschool" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13, color:C.coral, textDecoration:"none" }}>Explore the Preschool →</Link>
            </div>
            <div style={{ background:C.white, borderRadius:20, padding:"26px 28px", boxShadow:"0 4px 16px rgba(0,0,0,0.05)", borderTop:`5px solid ${C.navy}` }}>
              <div style={{ fontFamily:"Nunito", fontWeight:800, fontSize:11, letterSpacing:"0.06em", textTransform:"uppercase", color:C.navy, marginBottom:8 }}>A Dedicated Programme · Fully Online</div>
              <div style={{ fontFamily:"Fredoka One", fontSize:21, color:C.navy, marginBottom:8 }}>Quran for Kids</div>
              <p style={{ fontFamily:"Nunito", fontSize:14, color:C.text, lineHeight:1.75, margin:"0 0 12px" }}>Nine courses — Qaida to Tajweed, Seerah to Aqeeda — all delivered online, woven into one journey toward a child who owns their Muslim identity.</p>
              <Link to="/programs/quran-for-kids" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13, color:C.navy, textDecoration:"none" }}>Explore Quran for Kids →</Link>
            </div>
            <div style={{ background:C.white, borderRadius:20, padding:"26px 28px", boxShadow:"0 4px 16px rgba(0,0,0,0.05)", borderTop:`5px solid #8B6BE8` }}>
              <div style={{ fontFamily:"Nunito", fontWeight:800, fontSize:11, letterSpacing:"0.06em", textTransform:"uppercase", color:"#8B6BE8", marginBottom:8 }}>Ongoing</div>
              <div style={{ fontFamily:"Fredoka One", fontSize:21, color:C.navy, marginBottom:8 }}>Homeschooling Support Programme</div>
              <p style={{ fontFamily:"Nunito", fontSize:14, color:C.text, lineHeight:1.75, margin:"0 0 12px" }}>Your personalised weekly homeschool companion — after a one-time assessment, we plan your child's week so you just teach.</p>
              <Link to="/programs/homeschool-companion" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13, color:"#8B6BE8", textDecoration:"none" }}>Learn more →</Link>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>

    <section style={{ background:C.warmGray, padding:"90px 6vw" }}>
      <div style={{ maxWidth:900, margin:"0 auto", textAlign:"center" }}>
        <FadeIn>
          <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.coral, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:14 }}>A Different Kind of School</div>
          <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(26px,4vw,44px)", color:C.navy, margin:"0 0 20px", lineHeight:1.2 }}>This Is a Micro School.</h2>
          <p style={{ fontFamily:"Nunito", fontSize:15.5, color:C.text, lineHeight:1.9, maxWidth:700, margin:"0 auto 20px" }}>
            A micro school isn't a smaller version of a regular school — it's a different model altogether. Instead of one teacher managing 30+ children through a fixed syllabus, a micro school keeps enrolment deliberately small — <b style={{ color:C.navy }}>capped at 15 children</b> — so every child is known by name, by their choices, and by what makes them who they are. Ages mix naturally instead of being sorted into rigid grades, learning moves at each child's own pace, and the teacher acts as a mentor and guide rather than a lecturer managing a crowd.
          </p>
          <p style={{ fontFamily:"Nunito", fontSize:15.5, color:C.text, lineHeight:1.9, maxWidth:700, margin:"0 auto" }}>
            At Mini Muslims Nest, that small scale is what makes everything else possible — the personalised pace, the mothers present in the room, the teacher who actually notices when a child is struggling. It's not a constraint we work around. It's the whole point.
          </p>
        </FadeIn>
        <FadeIn delay={0.1}>
          <div style={{
            marginTop:36, background:C.navy, borderRadius:20, padding:"32px 36px",
            maxWidth:640, marginLeft:"auto", marginRight:"auto",
          }}>
            <p style={{ fontFamily:"Fredoka One", fontSize:"clamp(18px,2.5vw,24px)", color:C.white, margin:0, lineHeight:1.5 }}>
              Maximum 15 families. Maximum 15 children.<br/>
              <span style={{ color:C.yellow }}>In the whole school — not per class.</span>
            </p>
            <p style={{ fontFamily:"Nunito", fontSize:14, color:"rgba(255,255,255,0.7)", marginTop:12, marginBottom:0, lineHeight:1.75 }}>
              Other schools chase higher numbers. We chase higher quality — and quality doesn't scale by accident.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>

    <Vision />
    <Philosophy />
    <DaySchedule />
    <WeeklyStructure />

    <section style={{ background:C.white, padding:"70px 6vw" }}>
      <div style={{ maxWidth:1120, margin:"0 auto" }}>
        <FadeIn>
          <div style={{ textAlign:"center", marginBottom:36 }}>
            <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.navy, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:10 }}>Choose Your Format</div>
            <h3 style={{ fontFamily:"Fredoka One", fontSize:"clamp(20px,3vw,30px)", color:C.navy, margin:"0 0 10px" }}>One Philosophy, Four Ways to Reach It.</h3>
            <p style={{ fontFamily:"Nunito", fontSize:14, color:C.muted, maxWidth:560, margin:"0 auto 10px", lineHeight:1.8 }}>Not every family lives around the corner from us — and not every family needs to. The philosophy travels; only the format changes.</p>
            <Link to="/programs/preschool" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13, color:C.navy, textDecoration:"none" }}>See the full Preschool curriculum & how we track progress →</Link>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))", gap:18, alignItems:"start" }}>
            {[
              { label:"Fully Onsite",       color:C.mint,   body:"Five days a week on our school premises." },
              { label:"Fully Online",       color:C.coral,  body:"All 5 days live online — shorter, focused sessions." },
              { label:"Hybrid for Lahore",  color:C.yellow, body:"Academic days online, project days onsite." },
              { label:"Homeschooling Support Programme", color:"#8B6BE8", body:"Your personalised weekly homeschool companion.", link:"/programs/homeschool-companion" },
            ].map(({ label, color, body, link }) => (
              <div key={label} style={{
                background:C.white, borderRadius:16, padding:"22px 20px",
                borderTop:`5px solid ${color}`, boxShadow:"0 4px 14px rgba(0,0,0,0.06)",
                border:`1px solid ${C.warmGray}`, display:"flex", flexDirection:"column",
              }}>
                <div style={{ fontFamily:"Fredoka One", fontSize:16, color:C.navy, marginBottom:10 }}>{label}</div>
                <p style={{ fontFamily:"Nunito", fontSize:13, color:C.muted, lineHeight:1.7, margin:0, flex:1 }}>{body}</p>
                <Link to={link || "/programs/preschool"} style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12.5, color, textDecoration:"none", marginTop:14 }}>
                  Learn more →
                </Link>
              </div>
            ))}
          </div>
        </FadeIn>
      </div>
    </section>

    <ForMothers />

    <section style={{ background:C.cream, padding:"90px 6vw" }}>
      <div style={{ maxWidth:1100, margin:"0 auto" }}>
        <FadeIn>
          <div style={{ textAlign:"center", marginBottom:36 }}>
            <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.coral, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:10 }}>Beyond the Classroom</div>
            <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(24px,3.5vw,40px)", color:C.navy, margin:0 }}>More Ways to Learn With Us.</h2>
          </div>
        </FadeIn>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))", gap:20 }}>
          {[
            { icon:"📚", color:C.yellow,  title:"Paid Resources",   body:"Printable resource packs for learning at home — order yours.", to:"/resources" },
            { icon:"🎥", color:C.mint,    title:"Free Resources",   body:"Free videos and worksheets, open to every family.", to:"/free-resources" },
            { icon:"🎓", color:C.navy,    title:"Upcoming Courses", body:"Standalone courses for mothers, educators, and children — coming soon.", to:"/upcoming" },
          ].map(({ icon, color, title, body, to }, i) => (
            <FadeIn key={title} delay={i * 0.08}>
              <Link to={to} style={{ textDecoration:"none" }}>
                <div style={{
                  background:C.white, borderRadius:20, padding:"28px 24px",
                  boxShadow:"0 4px 16px rgba(0,0,0,0.05)", border:`2px solid ${color}18`,
                  height:"100%", transition:"transform 0.2s",
                }}
                  onMouseOver={e=>{e.currentTarget.style.transform="translateY(-3px)";}}
                  onMouseOut={e=>{e.currentTarget.style.transform="";}}
                >
                  <div style={{ fontSize:30, marginBottom:12 }}>{icon}</div>
                  <div style={{ fontFamily:"Fredoka One", fontSize:18, color, marginBottom:8 }}>{title}</div>
                  <p style={{ fontFamily:"Nunito", fontSize:13.5, color:C.text, lineHeight:1.7, margin:0 }}>{body}</p>
                </div>
              </Link>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>

    <Enrol />
  </div>
  );
};

export default Home;
